import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import * as actions from "../../../store/actions";
import { NO_DATA_FOUND, PCP_NOTIFICATION_LOGO } from "../../../constants";

import "../../../layout/Dashboard/dashboardStyle.css";
import "./notificationsStyle.css";

import NotificationList from "./NotificationList";

import { useInfiniteScroll } from "../../../utils/pagination";
import { getNotifications } from "../../../store/actions/notificationsActions";
import { NOTIFICATIONS_FEATURE_KEY } from "../../../store/reducer/notifications/notifications";
import { getUserData } from "../../../utils/localStorage";

import Modals from "../../../components/uiElements/popupModal/modal";

let Notifications = () => {
  const [page, setPage] = React.useState(0);
  const [isOpen, setIsOpen] = React.useState();

  const loader = useRef(null);

  useInfiniteScroll(loader, () => setPage(page => page + 1));

  const userData = getUserData();

  let dispatch = useDispatch();
  let notificationsList = useSelector(state => {
    return state[NOTIFICATIONS_FEATURE_KEY];
  });
  let { notificationsState, updateState, deletedNotification } =
    notificationsList;
  let { results, total_pages, count } = notificationsState;

  useEffect(() => {
    dispatch(actions.updateNoficationState());
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (page <= total_pages && page > 0) {
      dispatch(getNotifications(page));
    }
    //eslint-disable-next-line
  }, [updateState, deletedNotification, dispatch, page]);

  let openModal = value => {
    setIsOpen(value);
  };
  let closeModal = () => {
    setIsOpen(undefined);
  };

  return (
    <>
      <Modals
        isOpen={!!isOpen}
        onRequestClose={() => closeModal}
        title="Clear Notifications"
        btnDark={{
          label: "Clear",
          onclick: () => {
            closeModal();
            dispatch(actions.clearNotifications());
          },
        }}
        styles={{
          content: {
            minWidth: "500px",
            maxWidth: "500px",
            minHeight: "250px",
            maxHeight: "250px",
          },
        }}
      >
        <React.Fragment>
          <button
            onClick={closeModal}
            className="close modalCloseBtn"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p className="mx-auto text-center denyAppointmentText ">
            Are you want to clear all notifications
          </p>
        </React.Fragment>
      </Modals>
      <div className="">
        <div>
          <div className="w-100 d-flex">
            <p className="DBSubTitle mb-0">
              {results && results[0] && results[0]["unread_count"] !== 0
                ? `Notifications(${results[0]["unread_count"]})`
                : "Notifications"}
            </p>
            {results?.length > 0 && (
              <>
                <span
                  className="underlineLink ml-auto mr-2"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    results?.length > 0 && dispatch(actions.markAsRead())
                  }
                >
                  Mark all as read
                </span>
                <span
                  className="underlineLink  mr-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => results?.length > 0 && openModal(true)}
                >
                  Clear all
                </span>
              </>
            )}
          </div>
          <div className="mt-4">
            {results?.length > 0 ? (
              results?.map(notification => {
                return (
                  <React.Fragment key={notification.id}>
                    <NotificationList
                      img={PCP_NOTIFICATION_LOGO}
                      notification={notification}
                      physician={userData?.firstName}
                    />
                  </React.Fragment>
                );
              })
            ) : (
              <p className="text-center not-found-image">
                <img
                  src={NO_DATA_FOUND}
                  width={366}
                  height={300}
                  alt="notifcations-not-found"
                />
              </p>
            )}
            <div ref={loader}></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Notifications;
